// extracted by mini-css-extract-plugin
module.exports = {"droppable":"Droppable_droppable__1__15"};